import React from "react";

const COLORS = [
  "#e11d48", "#ec4899", "#d946ef", "#a855f7",
  "#8b5cf6", "#6366f1", "#3b82f6", "#0ea5e9",
  "#06b6d4", "#14b8a6", "#10b981", "#22c55e",
  "#84cc16", "#eab308", "#f59e0b", "#f97316",
];

function getInitials(name) {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function getColor(name) {
  if (!name) return COLORS[0];
  const idx = name.split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return COLORS[idx % COLORS.length];
}

const DashboardAvatar = ({ name, size = 32 }) => (
  <div
    className="db-avatar"
    style={{ width: size, height: size, fontSize: size * 0.38, background: getColor(name) }}
  >
    {getInitials(name)}
  </div>
);

export default DashboardAvatar;
